import styled from 'styled-components';

import { rem } from 'approot/shared/style';
import {
  spacing4,
  spacing8,
  spacing24,
} from 'approot/shared/styles/spacing.style';
import { BoxList } from 'approot/shared/design-system/box/box.style';
import { flexCentreAlignCss } from 'approot/shared/styles/flex.style';
import { MIN_LABEL_WIDTH } from './settings/interactive-response.constants';

export const InteractiveResponsePrintDragZone = styled(BoxList)`
  ${flexCentreAlignCss}
  align-items: flex-start;
  flex-wrap: wrap;
  margin: auto;
  min-height: ${rem(140)};
  padding-top: ${rem(spacing24)};
  position: relative;
`;

export const InteractiveResponsePrintDragZoneItem = styled.li`
  margin: 0 ${rem(spacing4)} ${rem(spacing8)};
`;

export const InteractiveResponsePrintDropZoneOuter = styled.div`
  text-align: center;
`;

export const InteractiveResponsePrintDropZone = styled(BoxList)`
  min-height: ${rem(140)};
  padding-top: ${rem(spacing24)};
`;

export const InteractiveResponsePrintDropZoneItem = styled.li<{
  $labelLength?: number | null;
}>`
  margin: 0 ${rem(spacing4)} ${rem(spacing8)};
  width: ${({ $labelLength }) => rem($labelLength || MIN_LABEL_WIDTH)};
  display: inline-block;
  vertical-align: top;
`;
